"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_platform_web_network_1 = require("@wattpad/client-platform-web-network");
/**
 *
 * @param {String} username users name
 * @param {String} hostName hostname for CSR/SSR CSR:relative url(https://www.wattpad.com), SSR:API domain
 * @returns {String | undefined} If enabled user return afpClientId else undefined
 */
var logErrorCb = function (errorRes, type) {
    var error;
    try {
        error = JSON.stringify(errorRes);
    }
    catch (_a) {
        error = "error stringifying errorRes";
    }
    type === "successError"
        ? console.error("AFP Author Lookup Error: malformed success response - ".concat(error))
        : console.error("AFP Author Lookup Error: ".concat(error));
};
var getAfpClientid = function (username, hostName) {
    return new Promise(function (resolve) {
        if (!username) {
            console.error("AFP Author Lookup Error: undefined user");
            return resolve(undefined);
        }
        var options = {
            url: "".concat(hostName, "/v5/adsense/authors/").concat(username, "/status"),
            method: "GET",
            timeoutValue: 1000,
        };
        return resolve((0, client_platform_web_network_1.fetch)(options)
            .then(function (userStatus) {
            if (userStatus && userStatus.isEnabled && userStatus.afpAccount) {
                return userStatus.afpAccount;
            }
            else {
                if (userStatus.isEnabled) {
                    logErrorCb(userStatus, "successError");
                }
                return undefined;
            }
        })
            .catch(function (err) {
            if (err.status === 404) {
                return undefined;
            }
            logErrorCb(err, "error");
            return undefined;
        }));
    });
};
exports.default = getAfpClientid;
